import { isValidDropdown, isValidText, isValidEmail, isValidPhone, isValidPostcode } from '../form-elements/validation';

// helper: personal form field type and validation function
// eslint-disable-next-line import/prefer-default-export
export const personalFieldTypes = () => [
    {
        type: 'dropdown',
        tag: 'select',
        func: isValidDropdown
    },
    {
        type: 'text',
        tag: 'input',
        func: isValidText
    },
    {
        type: 'email',
        tag: 'input',
        func: isValidEmail
    },
    {
        type: 'phone',
        tag: 'input',
        func: isValidPhone
    },
    {
        type: 'postcode',
        tag: 'input',
        func: isValidPostcode
    },
    {
        type: 'text-other',
        tag: 'input',
        func: isValidText
    }
];

// helper: payment form field type and validation function
export const AddressFieldWithAutocompleteTypes = () => [
    {
        type: 'g-autocomplete-text',
        tag: 'input',
        func: isValidText
    },
    {
        type: 'g-autocomplete-dropdown',
        tag: 'select',
        func: isValidDropdown
    },
    {
        type: 'g-autocomplete-postcode',
        tag: 'input',
        func: isValidPostcode
    }
];



// WEBPACK FOOTER //
// ./src/components/donation-contact/c-donation-contact.js